import { colors, mediaQueries } from '@everlywell/leaves';
import { Link } from 'gatsby';
import styled from 'styled-components';

const SubHeaderContent = styled.div`
  margin: 0 auto;
  height: 100%;
`;

const MobileContentWrapper = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* padding to match padding on leaves Header */
  padding: 0 calc(39px + 100% - 100vw) 0 24px;
  align-items: center;
  height: 100%;

  ${mediaQueries.forTabletHorizontalUp} {
    display: none;
  }
`;

const SubHeaderWrapper = styled.nav`
  width: 100%;
  background-color: #f6f6f6;
  height: 64px;
  position: fixed;
  /* Increased for new nav */
  top: 73px;
  border-bottom: 2px solid rgb(0 115 119 / 11%);

  /* Increased for new nav */
  ${mediaQueries.forDesktopUp} {
    top: 89px;
  }
`;

const DesktopContentWrapper = styled.div`
  display: none;

  ${mediaQueries.forTabletHorizontalUp} {
    flex-direction: row;
    display: flex;
    justify-content: space-between;
    /* padding to match padding on leaves Header */
    padding: 0 calc(47px + 100% - 100vw) 0 32px;
    align-items: center;
    height: 100%;
  }
`;

const Right = styled.ul`
  display: flex;
  flex-flow: row wrap;
  flex: 1 1 auto;
  justify-content: flex-end;
  max-height: 24px;
  overflow: hidden;

  li:not(:first-child) {
    margin-right: 24px;
  }
`;

const Left = styled.ul`
  display: flex;
`;

const TopicsLink = styled(Link)`
  color: ${colors.gray4};
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.3px;
  text-decoration: none;
  cursor: pointer;
  margin: 0 16px 0 8px;
`;

export {
  SubHeaderContent,
  MobileContentWrapper,
  SubHeaderWrapper,
  DesktopContentWrapper,
  Right,
  Left,
  TopicsLink,
};
